import React from 'react';
import { Hero } from '../components/Hero';
import { ArchitectureShowcase } from '../components/ArchitectureShowcase';
import { EditorialStatement } from '../components/EditorialStatement';
import { BenchmarkGrid } from '../components/BenchmarkGrid';
import { SdkPlayground } from '../components/SdkPlayground';
import { Pricing } from '../components/Pricing';
import { WaitlistSection } from '../components/WaitlistSection';
import { Faq } from '../components/Faq';

export const HomePage: React.FC = () => {
  return (
    <>
      {/* 1. Fullscreen Mountain Landscape Hero */}
      <Hero />

      {/* 2. Architecture Showcase (Matches micro1 Intelligence section) */}
      <ArchitectureShowcase />

      {/* 3. Spacious Editorial Divider Statement */}
      <EditorialStatement 
        headline="The identity platform to accelerate modern software in the real world"
      />

      {/* 4. Research & Benchmarks Grid (Matches micro1 Research section) */}
      <BenchmarkGrid />

      {/* 5. Developer Experience (Interactive 3-line SDK) */}
      <SdkPlayground />

      {/* 6. Honest Transparent INR Pricing (5 Tiers + Addons + Estimator + Guarantees) */}
      <Pricing />

      {/* 7. Second Editorial Divider Statement */}
      <EditorialStatement 
        headline="Engineering sovereignty is needed more than ever"
        subtext="Zero captive hashes, zero SAML taxes, and zero telephony fraud bill shocks."
      />

      {/* 8. Early Access VIP Registration Form */}
      <WaitlistSection />

      {/* 9. Developer FAQ */}
      <Faq />
    </>
  );
};

export default HomePage;
